import {getCookieByName, setCookie, useConfig, useRouter} from "@/plugins/obscore";
import {postRequest} from "@/plugins/axioscalls";
import cryptojs from 'crypto-js'

export default {
    state: {
        _token: null,
        isAuthenticated: false,
    },
    getters: {
        token() {
            if (!this._token)
                this._token = getCookieByName("token") ? JSON.parse(getCookieByName("token")) : null
            this.isAuthenticated = !!this._token;
            return this._token
        },
    },
    actions: {
        prepareRequest(config, isPublic) {
            config.headers = config.headers ? config.headers : {}


            if (!isPublic) {
                let date = new Date().toISOString().match(/(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})/)
                date = date[1] + ' ' + date[2]
                const nonce = cryptojs.enc.Base64.stringify(cryptojs.lib.WordArray.random(128/8))
                const pass = cryptojs.enc.Base64.stringify(cryptojs.SHA512(nonce+date+this.token.t))
                // console.log(cryptojs.SHA512("jGkcBugRZloQFkjT7cCNHg==2022-11-15 19:48:081064aa2427a9eb90e7b2d1ed59336a13"))
                // console.log(cryptojs.enc.Base64.stringify(cryptojs.SHA512("jGkcBugRZloQFkjT7cCNHg==2022-11-15 19:48:081064aa2427a9eb90e7b2d1ed59336a13")))
                config.headers['x-wsse'] = 'UsernameToken Username="' + this.token.i + '", PasswordDigest="'+pass+'", Nonce="'+nonce+'", Created="'+date+'"'
            }
            config.headers.Accept = 'application/json'
            return config
        },
        async login(params) {
            let store = this;
            const config = useConfig()
            await postRequest(config.auth.loginURL, params.value, {
                headers: {
                    'Accept': '*',
                    'Content-type': 'multipart/form-data',
                }
            }, 1)
                .then((data) => {
                    store._token = {
                        t: data.data.data.token,
                        i: data.data.data.id
                    }
                    setCookie('token', JSON.stringify(store._token))
                    if (store.lastVisitedRoute) {
                        useRouter().push(store.lastVisitedRoute)
                    } else {
                        useRouter().push("/")
                    }
                })
        },
        logout() {
            this._token = null
            this.isAuthenticated = false
            setCookie('token', null)
            useRouter().push("login")
        }
    }
}